// extracted by mini-css-extract-plugin
module.exports = {"main":"DefaultLayout_main__HDlyD"};